export default "__VITE_ASSET__CBOneljw__"